import React from "react";
import { useState } from "react";

function ModalPelatihan({ openModal }) {
  const [checkedOne, setCheckedOne] = useState(false);

  const handleChangeOne = () => {
    setCheckedOne(!checkedOne);
  };

  return (
    <div className="modalBackground">
      <div className="modalContainer">
        <button
          onClick={() => {
            openModal(false);
          }}
          className="modalCloseButton"
        >
          X{" "}
        </button>
        <div className="modalTitle">
          <h1>Nama UMKM</h1>
        </div>

        <div className="modalBody">
          <div className="anggotaUmkmCheckBox">
            <label>
              <input
                value={checkedOne}
                onChange={handleChangeOne}
                className="modalCheckBox"
                type="checkbox"
              />
              Nama Anggota
            </label>
          </div>

          <div className="anggotaUmkmCheckBox">
            <label>
              <input
                value={checkedOne}
                onChange={handleChangeOne}
                className="modalCheckBox"
                type="checkbox"
              />
              Nama Anggota
            </label>
          </div>

          <div className="anggotaUmkmCheckBox">
            <label>
              <input
                value={checkedOne}
                onChange={handleChangeOne}
                className="modalCheckBox"
                type="checkbox"
              />
              Nama Anggota
            </label>
          </div>

          <div className="anggotaUmkmCheckBox">
            <label>
              <input
                value={checkedOne}
                onChange={handleChangeOne}
                className="modalCheckBox"
                type="checkbox"
              />
              Nama Anggota
            </label>
          </div>

          <div className="anggotaUmkmCheckBox">
            <label>
              <input
                value={checkedOne}
                onChange={handleChangeOne}
                className="modalCheckBox"
                type="checkbox"
              />
              Nama Anggota
            </label>
          </div>
        </div>

        <div className="modalFooter">
          <button className="modalButtons">Daftar</button>
        </div>
      </div>
    </div>
  );
}

export default ModalPelatihan;
